import { type Firestore, collection, doc } from "firebase/firestore"

export const getTasksCollectionRef = (db: Firestore) =>
  collection(db, "public/data/tasks")

export const getTeamsCollectionRef = (db: Firestore) =>
  collection(db, "public/data/teams")

export const getRolesCollectionRef = (db: Firestore) =>
  collection(db, "public/data/roles")

export const getUserRoleDocRef = (db: Firestore, userId: string) =>
  doc(db, `users/${userId}/profile/role`)

export const getUserPublicProfileDocRef = (db: Firestore, userId: string) =>
  doc(db, "public/data/users", userId)

export const getGlobalSettingsDocRef = (db: Firestore) =>
  doc(db, "public/data/settings/annualHours")

export const getSpondImportSettingsDocRef = (db: Firestore) =>
  doc(db, "public/data/settings/spondImport")

export const getCampaignEmailSettingsDocRef = (db: Firestore) =>
  doc(db, "public/data/settings/campaignEmail")

export const getAutomationRulesCollectionRef = (db: Firestore) =>
  collection(db, "public/data/automationRules")

export const getAutomationRuleDocRef = (db: Firestore, ruleId: string) =>
  doc(db, "public/data/automationRules", ruleId)

export const getAutomationLogsCollectionRef = (db: Firestore) =>
  collection(db, "public/data/automationLogs")

export const getUsersCollectionRef = (db: Firestore) =>
  collection(db, "public/data/users")

export const getPendingNotificationsCollectionRef = (db: Firestore) =>
  collection(db, "public/data/pendingNotifications")

export const getCalendarFeedsCollectionRef = (db: Firestore) =>
  collection(db, "public/data/calendarFeeds")

export const getSyncChangesCollectionRef = (db: Firestore) =>
  collection(db, "public/data/syncChanges")

export const getActivityTypesCollectionRef = (db: Firestore) =>
  collection(db, "public/data/activityTypes")

export const getActivityTemplatesCollectionRef = (db: Firestore) =>
  collection(db, "public/data/activityTemplates")

export const getPersonsCollectionRef = (db: Firestore) =>
  collection(db, "public/data/persons")

export const getFamilyMembershipsCollectionRef = (db: Firestore) =>
  collection(db, "public/data/familyMemberships")

export const getGuardianLinksCollectionRef = (db: Firestore) =>
  collection(db, "public/data/guardianLinks")

export const getLinkRequestsCollectionRef = (db: Firestore) =>
  collection(db, "public/data/linkRequests")

export const getTiersCollectionRef = (db: Firestore) =>
  collection(db, "system/tiers")

export const getTierDocRef = (db: Firestore, tierId: string) =>
  doc(db, "system/tiers", tierId)

export const getFeatureFlagDefinitionsCollectionRef = (db: Firestore) =>
  collection(db, "system/featureFlags")

export const getTenantConfigDocRef = (db: Firestore) => doc(db, "public/config")
